import type { CancelOffer, CancelReason, ResultsPeriod, SubscriptionResults } from 'types/engagement.types';
import { API_V1 } from './APIs/APIv1';
import { call } from './engagement';

/** Customer subscription endpoints of the Engagement Center (cancel dialog, pause, own results). */

export const getSubscriptionResults = (period: ResultsPeriod = 'lifetime') =>
  call<SubscriptionResults>(() => API_V1.get('/subscription/results', { params: { period } }));

export const postCancelIntent = (reason: CancelReason, comment?: string) =>
  call<{ offer: CancelOffer; feedbackId: string }>(() => API_V1.post('/subscription/cancel-intent', { reason, comment: comment || undefined }));

export const pauseSubscription = (months: 1 | 2 | 3) => call<unknown>(() => API_V1.post('/subscription/pause', { months }));

export const resumeSubscription = () => call<unknown>(() => API_V1.post('/subscription/resume'));
